module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "grid grid-pad box-size subs-today-grid"
  }, [_c('div', {
    staticClass: "subs-today text-dark"
  }, [_c('div', {
    staticClass: "subs-today__header"
  }, [(_vm.isSubsToday) ? _c('h1', [_vm._v(_vm._s(_vm.substitutesToday.length) + " " + _vm._s(_vm.i18n[_vm.locale]['subs']) + ", "), _c('span', {
    staticClass: "headline-date"
  }, [_vm._v(_vm._s(_vm.formattedDayDate))])]) : _c('h1', [_vm._v(_vm._s(_vm.absentToday.length) + " " + _vm._s(_vm.i18n[_vm.locale]['absent']) + ", "), _c('span', {
    staticClass: "headline-date"
  }, [_vm._v(_vm._s(_vm.formattedDayDate))])]), _vm._v(" "), _c('div', {
    staticClass: "subs-today__header__right no-print"
  }, [_c('button', {
    staticClass: "date-buttons marg-5-right",
    class: {
      'bttn--disabled': _vm.getIsToday
    },
    on: {
      "click": _vm.setToday
    }
  }, [_vm._v("\n          " + _vm._s(_vm.i18n[_vm.locale]['today']) + "\n        ")]), _vm._v(" "), _c('button', {
    staticClass: "date-buttons marg-5-right",
    on: {
      "click": _vm.prevDay
    }
  }, [_c('span', {
    staticClass: "icon-arrow-left4"
  })]), _vm._v(" "), _c('DatePicker', {
    attrs: {
      "date": _vm.date
    },
    on: {
      "changed": _vm.setDate
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "marg-5-left date-buttons",
    on: {
      "click": _vm.nextDay
    }
  }, [_c('span', {
    staticClass: "icon-arrow-right4"
  })]), _vm._v(" "), (_vm.isSubsToday) ? _c('button', {
    staticClass: "marg-1-left",
    on: {
      "click": _vm.asyncLoadXLSXAndDownload
    }
  }, [_vm._v(_vm._s(_vm.i18n[_vm.locale]['download']) + "\n        ")]) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "marg-1-left",
    on: {
      "click": _vm.print
    }
  }, [_c('span', {
    staticClass: "icon-printer3"
  })]), _vm._v(" "), _c('button', {
    staticClass: "marg-1-left marg-1-right",
    on: {
      "click": _vm.startSlider
    }
  }, [(_vm.isSlider) ? _c('span', {
    staticClass: "icon-shrink7"
  }) : _c('span', {
    staticClass: "icon-enlarge2"
  })])], 1)]), _vm._v(" "), (_vm.isLoading) ? _c('Loader') : _vm._e(), _vm._v(" "), (_vm.isSubsToday && !_vm.isLoading && _vm.substitutesToday.length < 1) ? _c('h2', {
    staticClass: "text-explainer"
  }, [_vm._v(_vm._s(_vm.i18n[_vm.locale]['no_subs_today']) + "\n    ")]) : _vm._e(), _vm._v(" "), (!_vm.isSubsToday && !_vm.isLoading && _vm.absentToday.length < 1) ? _c('h2', {
    staticClass: "text-explainer"
  }, [_vm._v(_vm._s(_vm.i18n[_vm.locale]['no_one_absent_today']) + "\n    ")]) : _c('div', {
    staticClass: "users-today__container"
  }, [_vm._l((_vm.usersInArraysSlider), function(userRow, key) {
    return (!_vm.isSlider || key === _vm.theSliderIndex) ? _c('div', {
      staticClass: "subs-grid"
    }, _vm._l((userRow), function(user) {
      return _c('div', {
        key: user.id,
        staticClass: "subs-today__sub",
        attrs: {
          "data-user-id": user.id
        }
      }, [_c('h3', [_vm._v(_vm._s(user.name))]), _vm._v(" "), _vm._l((user.absence), function(absence) {
        return _c('p', {
          staticClass: "subs-today__sub__absence"
        }, [_vm._v(_vm._s(absence.title) + " -\n            " + _vm._s(absence.timeFormatted) + "\n          ")])
      }), _vm._v(" "), (user.events.length < 1) ? _c('p', {
        staticClass: "text-explainer marg-1-top"
      }, [_vm._v(_vm._s(_vm.i18n[_vm.locale]['no_lessons_effected']))]) : _vm._e(), _vm._v(" "), (user.events.length > 0) ? _c('table', {
        staticClass: "d-table"
      }, [_c('thead', [_c('th', [_vm._v(_vm._s(_vm.i18n[_vm.locale]['course']))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.i18n[_vm.locale]['grade']))]), _vm._v(" "), (_vm.isShowRooms) ? _c('th', [_vm._v(_vm._s(_vm.i18n[_vm.locale]['room']))]) : _vm._e(), _vm._v(" "), _c('th', {
        class: {
          'd-table__subs-for': !_vm.isShowRooms
        }
      }, [(!_vm.isSubsToday) ? [_vm._v(_vm._s(_vm.i18n[_vm.locale]['sub']))] : [_vm._v(_vm._s(_vm.i18n[_vm.locale]['sub_for']))]], 2)]), _vm._v(" "), _c('tbody', _vm._l((user.events), function(event) {
        return _c('tr', {
          key: event.id
        }, [_c('td', [_c('div', {
          staticClass: "subs-today__event-title"
        }, [_vm._v(_vm._s(event.title))]), _vm._v("\n                " + _vm._s(event.timeFormatted) + "\n              ")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(event.grades))]), _vm._v(" "), (_vm.isShowRooms) ? _c('td', [_vm._v(_vm._s(event.rooms))]) : _vm._e(), _vm._v(" "), _c('td', [(!_vm.isSubsToday) ? [_vm._v(_vm._s(event.substitute))] : [_vm._v(_vm._s(event.substitute_for))]], 2)])
      }), 0)]) : _vm._e()], 2)
    }), 0) : _vm._e()
  }), _vm._v(" "), (_vm.isSlider) ? _c('div', {
    staticClass: "users-today__slider-pager marg-2-top"
  }, [_c('p', [_vm._v(_vm._s(_vm.theSliderIndex + 1) + " / " + _vm._s(_vm.userInRows.length))]), _vm._v(" "), (_vm.userInRows.length > 1) ? _c('div', {
    staticClass: "d-progress"
  }, [_c('div', {
    staticClass: "d-progress__bar",
    style: ({
      'width': _vm.animatePercentage
    })
  })]) : _vm._e()]) : _vm._e()], 2)], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-0f93c863!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Subs/OverviewToday.vue
// module id = 1455
// module chunks = 1